import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import { Divider } from "@mui/material";
import { AddIcon } from "../../../Resources/Icons/icons";
import {
  GetFinancier,
  UpdateFinancier,
  FilterFinancier,
} from "../../../Service/_index";
import { Transition } from "../../../UiComponents/Transition/Transition";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import AddFinancier from "./AddFinancier";

const headCells = [
  { id: "financierType", label: "Financier Type", placeMent: true },
  { id: "financierName", label: "Financier Name", placeMent: true },
  { id: "financierAddress", label: "Financier Address", placeMent: true },
  { id: "status", label: "Status" },
];

const Financier = () => {
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [selectedData, setSelectedData] = React.useState({});
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [financiers, setFinanciers] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [tableConfig, setTableConfig] = React.useState({
    isAction: true,
    isEdit: true,
    isMultiDelete: false,
    isSearch: false,
    isSwitch: false,
    historyEntity: "financier",
  });

  const GetData = () => {
    setLoading(true);
    GetFinancier().then((res) => {
      if (res && res.data) setFinanciers(res.data);
    });
    setLoading(false);
  };

  React.useEffect(() => {
    GetData();
  }, []);

  const CreateData = () => {
    setSelectedData({});
    setOpenDrawer(true);
  };

  return (
    <>
      <Grid container className="Master_Card_Container">
        <Grid
          container
          alignItems={"center"}
          className="Master_Card_Sub_Container"
        >
          <Grid item xs={12} sm={6} md={6}>
            <Typography className="Master_Card_Tittle">Financier</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            className="d-flex justify-content-end"
          >
            <Button
              className="Master_Card_create_Button w-100"
              startIcon={<AddIcon />}
              onClick={() => CreateData()}
            >
              Create
            </Button>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ backgroundColor: "#EAECF0", borderWidth: 1 }} />
        </Grid>

        <MasterCommonTable
          tableConfig={tableConfig}
          data={financiers}
          columns={headCells}
          handleEdit={(row) => {
            setSelectedData(row);
            setOpenDrawer(true);
          }}
          tableTotalCount={financiers?.length || 0}
          loading={loading}
        />
      </Grid>

      <Dialog
        open={openDrawer}
        TransitionComponent={Transition}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: { maxWidth: { xs: "80%", sm: "70%", md: "50%", lg: "40%" } },
        }}
      >
        {openDrawer ? (
          <AddFinancier
            title={selectedData._id ? "Edit" : "Create"}
            selectedData={selectedData}
            formType={selectedData._id ? "edit" : "add"}
            setOpenDrawer={setOpenDrawer}
            GetData={GetData}
          />
        ) : null}
      </Dialog>
    </>
  );
};

export default Financier;
